import { render } from "./MoveUserAdmin.vue?vue&type=template&id=6b37e7f4"
import script from "./MoveUserAdmin.vue?vue&type=script&lang=js"
export * from "./MoveUserAdmin.vue?vue&type=script&lang=js"

import "./MoveUserAdmin.vue?vue&type=style&index=0&id=6b37e7f4&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__